// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Bonuses_gamecard_window__b1m-A {
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.Bonuses_noBonus__Djk-a{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap:10px;
    color: white;
    font-family: Poppins, sans-serif;

}
.Bonuses_cancel__wLkuo{
    background-color: rgba(255, 0, 0, 0.379);
}
.Bonuses_gamecard_window__b1m-A img {
    height: 100%;
    object-fit: cover;
    width: 100%;

}
.Bonuses_description__dKkCo {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 16px;
}

.Bonuses_positionRight__Msa04{
    position: absolute;
    top:10px;
    right: 10px;


}
.Bonuses_positionLeft__8L3Q0{
    position: absolute;
    top:10px;
    left: 10px;


}
.Bonuses_activeCard__I8nRy{

    background-color: #a1f71bdb;
    padding: 10px;
    border-radius: 10px;

    z-index: 2;
}
.Bonuses_cardContainer__mZ-de{
    display: flex;
    justify-content: center;
    flex-direction: row;
    gap:10px;
    flex-wrap: wrap;
}
.Bonuses_main__eyTiO{
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    
    flex-direction: column;
    
    gap:10px;
}
.Bonuses_content__d-CmJ{
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
}
.Bonuses_header__a1jdn{
    color: white;
    font-size: 20px;
    font-family: Gilroy, sans-serif;
    text-align: center;
}
.Bonuses_header__a1jdn a{
    color: #ffc000;
    font-size: 17px;
}

.Bonuses_skeleton__bVRoe {
    height: 200px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    /*background-color: green;*/
    /*background-image: -webkit-linear-gradient(left, #ececec 0px, #f4f4f4 40px, #ececec 80px);*/
    /*background-image: -o-linear-gradient(left, #ececec 0px, #f4f4f4 40px, #ececec 80px);;*/
    /*background-image: linear-gradient(90deg, #ececec 0px, #f4f4f4 40px, #ececec 80px);*/
    /*background-size: 250px;*/
    /*-webkit-animation: shine-loading-image 2s infinite ease-out;*/
    /*animation: shine-loading-image 2s infinite ease-out;*/
}

.Bonuses_card__zH2ZD {
    position: relative;
    opacity: 1;
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0 4px 10px 0 #483886;
    background-color: #3a4495;
    transition: transform 0.8s ease, box-shadow 0.3s ease, opacity 0.8s ease;
}`, "",{"version":3,"sources":["webpack://./src/components/Bonuses/Bonuses.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,gCAAgC;;AAEpC;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,WAAW;;AAEf;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;;;AAGf;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;;;AAGd;AACA;;IAEI,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;;IAEnB,UAAU;AACd;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;;IAEvB,sBAAsB;;IAEtB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,YAAY;IACZ,eAAe;IACf,+BAA+B;IAC/B,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;IAC3B,4FAA4F;IAC5F,wFAAwF;IACxF,qFAAqF;IACrF,0BAA0B;IAC1B,+DAA+D;IAC/D,uDAAuD;AAC3D;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,yBAAyB;IACzB,wEAAwE;AAC5E","sourcesContent":[".gamecard_window {\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n}\n.noBonus{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap:10px;\n    color: white;\n    font-family: Poppins, sans-serif;\n\n}\n.cancel{\n    background-color: rgba(255, 0, 0, 0.379);\n}\n.gamecard_window img {\n    height: 100%;\n    object-fit: cover;\n    width: 100%;\n\n}\n.description {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    font-size: 16px;\n}\n\n.positionRight{\n    position: absolute;\n    top:10px;\n    right: 10px;\n\n\n}\n.positionLeft{\n    position: absolute;\n    top:10px;\n    left: 10px;\n\n\n}\n.activeCard{\n\n    background-color: #a1f71bdb;\n    padding: 10px;\n    border-radius: 10px;\n\n    z-index: 2;\n}\n.cardContainer{\n    display: flex;\n    justify-content: center;\n    flex-direction: row;\n    gap:10px;\n    flex-wrap: wrap;\n}\n.main{\n    margin-top: 20px;\n    margin-bottom: 20px;\n    display: flex;\n    justify-content: center;\n    \n    flex-direction: column;\n    \n    gap:10px;\n}\n.content{\n    display: flex;\n    height: 100%;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    color: white;\n}\n.header{\n    color: white;\n    font-size: 20px;\n    font-family: Gilroy, sans-serif;\n    text-align: center;\n}\n.header a{\n    color: #ffc000;\n    font-size: 17px;\n}\n\n.skeleton {\n    height: 200px;\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    /*background-color: green;*/\n    /*background-image: -webkit-linear-gradient(left, #ececec 0px, #f4f4f4 40px, #ececec 80px);*/\n    /*background-image: -o-linear-gradient(left, #ececec 0px, #f4f4f4 40px, #ececec 80px);;*/\n    /*background-image: linear-gradient(90deg, #ececec 0px, #f4f4f4 40px, #ececec 80px);*/\n    /*background-size: 250px;*/\n    /*-webkit-animation: shine-loading-image 2s infinite ease-out;*/\n    /*animation: shine-loading-image 2s infinite ease-out;*/\n}\n\n.card {\n    position: relative;\n    opacity: 1;\n    display: flex;\n    flex-direction: column;\n    border-radius: 5px;\n    overflow: hidden;\n    box-shadow: 0 4px 10px 0 #483886;\n    background-color: #3a4495;\n    transition: transform 0.8s ease, box-shadow 0.3s ease, opacity 0.8s ease;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gamecard_window": `Bonuses_gamecard_window__b1m-A`,
	"noBonus": `Bonuses_noBonus__Djk-a`,
	"cancel": `Bonuses_cancel__wLkuo`,
	"description": `Bonuses_description__dKkCo`,
	"positionRight": `Bonuses_positionRight__Msa04`,
	"positionLeft": `Bonuses_positionLeft__8L3Q0`,
	"activeCard": `Bonuses_activeCard__I8nRy`,
	"cardContainer": `Bonuses_cardContainer__mZ-de`,
	"main": `Bonuses_main__eyTiO`,
	"content": `Bonuses_content__d-CmJ`,
	"header": `Bonuses_header__a1jdn`,
	"skeleton": `Bonuses_skeleton__bVRoe`,
	"card": `Bonuses_card__zH2ZD`
};
export default ___CSS_LOADER_EXPORT___;
